<template>
  <v-card flat outlined class="grey lighten-4">
    <v-card-text>
      <v-row>
        <v-col cols="12">Påverkade sträcka/sträckor</v-col>
        <template v-if="!disabled">
          <v-col cols="5">
            <v-autocomplete
              :items="stops"
              item-value="short_name"
              :item-text="item => `(${item.short_name}) ${item.stop_name}`"
              :filter="
                (item, query) =>
                  item.short_name.toLowerCase().includes(query.toLowerCase()) ||
                  item.stop_name.toLowerCase().includes(query.toLowerCase())
              "
              outlined
              label="Från plats"
              v-model="from_place"
              hide-details
              ref="routeStartPlace"
            />
          </v-col>
          <v-col cols="5">
            <v-autocomplete
              :items="stops"
              item-value="short_name"
              :item-text="item => `(${item.short_name}) ${item.stop_name}`"
              :filter="
                (item, query) =>
                  item.short_name.toLowerCase().includes(query.toLowerCase()) ||
                  item.stop_name.toLowerCase().includes(query.toLowerCase())
              "
              outlined
              ref="routeEndPlace"
              label="Till plats"
              v-model="to_place"
              hide-details
              @change="goToRouteBtn"
            />
          </v-col>

          <v-col cols="2" class="mt-2">
            <v-btn
              color="primary"
              icon
              large
              @click="addRoute"
              ref="routeAddBtn"
              @keydown.prevent.enter="goBackToRouteStartPlace"
              :disabled="disableAddButton"
              :tabindex="disableAddButton ? -1 : 0"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </template>
        <v-col cols="12">
          <!-- <v-autocomplete
            style="display: none"
            v-model="eventRoutes"
            item-value="uuid"
            item-text="uuid"
            :items="[]"
            :rules="[required]"
            :disabled="true"
          /> -->

          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <template v-if="eventRoutes.length">
            <v-chip-group active-class="primary--text" column tabindex="-1">
              <v-chip
                v-for="route in eventRoutes"
                :key="route.uuid"
                :disabled="disabled"
                tabindex="-1"
                hide-details
              >
                {{ route.from_place }} - {{ route.to_place }}

                <v-icon
                  small
                  right
                  tabindex="-1"
                  v-if="!disabled"
                  @click="removeRoute(route.uuid)"
                >
                  mdi-close-circle
                </v-icon>
              </v-chip>
            </v-chip-group>
          </template>
          <!-- <p v-else class="d-flex align-center error--text">
            <v-icon class="mr-2" color="error">mdi-information-outline</v-icon>
            Minst en sträcka måste läggas till
          </p> -->
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'EventRoutesField',

  props: {
    disabled: Boolean
  },

  data: () => ({
    required,
    from_place: null,
    to_place: null
  }),

  computed: {
    eventRoutes: sync('event/model@routes'),
    event_uuid: sync('event/model@uuid'),
    stops: get('event/stops'),

    disableAddButton() {
      return this.from_place === null || this.to_place === null
    }
  },

  methods: {
    goBackToRouteStartPlace() {
      this.addRoute()
      this.$nextTick(() => this.$refs.routeStartPlace.focus())
    },

    goToRouteBtn() {
      this.$nextTick(() => this.$refs.routeEndPlace.blur())
      this.$nextTick(() => this.$refs.routeAddBtn.$el.focus())
    },

    addRoute() {
      const route = {
        from_place: this.from_place,
        to_place: this.to_place,
        uuid: uuidv4()
      }
      const routes = [...this.eventRoutes, route]
      this.$store.set('event/model@routes', routes)

      this.from_place = null
      this.to_place = null
    },

    removeRoute(uuid) {
      const index = this.eventRoutes.findIndex(x => x.uuid === uuid)
      if (index >= 0) this.eventRoutes.splice(index, 1)
      this.$store.set('event/model@routes', this.eventRoutes)
    }
  }
}
</script>
